import React from "react";
import {LinearProgress} from "@material-ui/core";

const ProgressBar = () => {
    return (
        <LinearProgress color='secondary' />
    )
}
export default ProgressBar;
